<div class="row justify-content-center align-items-center mt-3 d-flex flex-lg-row-reverse">
  <div class="col-lg-6 col-12">
    <div class="row justify-content-center mt-4">
      <div class="col-8 blue_box p-4 text-center">
        <h3 class="heading">Redirecting to 1Fi</h3>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-11 white_box p-4 text-center">
        <!-- Redirecting state -->
        <div *ngIf="!hasError" class="py-4">
          <div class="spinner-border text-primary my-4" role="status" style="width: 3rem; height: 3rem; color: #002d3a !important;">
            <span class="visually-hidden">Loading...</span>
          </div>

          <h4 class="mt-3">Please wait...</h4>
          <p class="text-muted mt-2">Redirecting to complete your verification.</p>

          <p *ngIf="redirectUrl" class="small text-muted mt-4">
            If you are not redirected automatically, 
            <a href="javascript:void(0)" (click)="redirectNow()" class="font-weight-bold" style="color: #044b5f; text-decoration: underline;">click here</a>.
          </p>
        </div>

        <!-- Error state -->
        <div *ngIf="hasError" class="py-4">
          <div class="text-danger my-3">
            <i class="fas fa-exclamation-circle fa-3x"></i>
          </div>

          <h4 class="mt-3 text-danger">Something went wrong</h4>
          <p class="text-muted mt-2">{{ errorMessage }}</p>

          <div class="mt-4">
            <button type="button" class="btn btn-warning" (click)="retry()">
              Try Again
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-lg-5 col-11">
    <app-assist-left></app-assist-left>
  </div>
</div>
<ngx-spinner type="ball-spin-clockwise" size="medium"></ngx-spinner>
